import withDirection from 'src/settings/withDirection';
import styled from 'styled-components';
import { palette } from 'styled-theme';

const SearchInputStyles = styled('div')`
  position: relative;
  width: 100%;
  display: flex;
  align-items: center;

  .search-input-icon {
    position: absolute;
    left: ${props => (props['data-rtl'] === 'rtl' ? 'auto' : '20px')};
    right: ${props => (props['data-rtl'] === 'rtl' ? '20px' : 'auto')};
    display: flex;
    align-items: center;
    width: 18px;
    height: 18px;
    pointer-events: none;
  }
`;

const ClearButtonStyles = styled('div')`
  .global-search-clear-button {
    margin-top: 7px;
    margin-left: ${props => (props['data-rtl'] === 'rtl' ? '14px' : '0')} !important;
    margin-right: ${props => (props['data-rtl'] === 'rtl' ? '0' : '14px')} !important;

    svg {
      color: ${palette('globalSearch', 5)};
    }
  }
`;

export const SearchInput = withDirection(SearchInputStyles);
export const ClearButton = withDirection(ClearButtonStyles);
